import axios from "@util/axios";

const defaultState = () => {
  return {
    tags: [],
    tag: {
      id: 0,
      value: "",
    },
  };
};

const state = {
  tags: defaultState().tags,
  tag: defaultState().tag,
};

const getters = {
  tags: (state) => state.tags,
  tag: (state) => state.tag,
};

const actions = {
  fetchTags: async ({ commit }) => {
    const resp = await axios({
      url: `/tag/`,
    });

    commit("SET_TAGS", resp.data.data.results);
  },
  createTag: async ({ commit }, name) => {
    const resp = await axios({
      url: `/tag/`,
      method: "POST",
      data: {
        name: name,
      },
    });

    commit("CREATE_TAG", resp.data.data.data);
  },
  readTag: async ({ commit }, id) => {
    const resp = await axios({
      url: `/tag/${id}/`,
    });

    commit("READ_TAG", resp.data.data.data);
  },
  updateTag: async ({ commit }, { id, name }) => {
    const resp = await axios({
      url: `/tag/${id}/`,
      method: "PUT",
      data: {
        name: name,
      },
    });

    commit("UPDATE_TAG", resp.data.data.data);
  },
  deleteTag: async ({ commit }, id) => {
    await axios({
      url: `/tag/${id}/`,
      method: "DELETE",
    });

    commit("DELETE_TAG", id);
  },
};

const mutations = {
  SET_TAGS: (state, payload) => {
    if (payload) state.tags = payload;
    else state.tags = defaultState().tags;
  },
  CREATE_TAG: (state, payload) => {
    state.tags.push(payload);
  },
  READ_TAG: (state, payload) => {
    state.tag = payload;
  },
  UPDATE_TAG: (state, payload) => {
    const index = state.tags.findIndex((item) => item.id == payload.id);

    if (0 > index) state.tag = defaultState().tag;
    else state.tags.splice(index, 1, payload);
  },
  DELETE_TAG: (state, id) => {
    const index = state.tags.findIndex((item) => item.id == id);

    if (0 > index) return;

    state.tags.splice(index, 1);
  },
};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations,
};
